"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLocalizedDateFormat = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2020 GoodData Corporation
var moment_1 = tslib_1.__importDefault(require("moment"));
var util_1 = require("@gooddata/util");
exports.getLocalizedDateFormat = function (locale) {
    var localizedMoment = moment_1.default().locale(util_1.translationUtils.sanitizeLocaleForMoment(locale));
    var localeData = localizedMoment && localizedMoment.localeData && localizedMoment.localeData();
    return localeData && localeData._longDateFormat && localeData._longDateFormat.L;
};
//# sourceMappingURL=FormattingUtils.js.map